export default __webpack_public_path__ + "static/media/dialog-chat.6c140d53.svg";